<template>
    <v-container :style="cssProps">
        <Banner v-if="multiplasCotas"
                type="warning"
                icon="mdi-information"
                title="Informativo"
        >
            É possível alterar a forma de pagamento na tela de
            <strong>"Minhas Vendas"</strong>, ao clicar em
            <strong>"Detalhes"</strong> → <strong>"Situação de pagamento/contratos"</strong>.
            <br>Seu cliente receberá <strong>um e-mail contendo um boleto para cada cota comprada*</strong>
        </Banner>
        <h2 class="titulo">Forma de Pagamento</h2>

        <div class="forma-pagamento mx-auto">
            <div class="text-center d-flex align-start justify-center">
                <v-label v-if="!multiplasCotas">Selecione uma forma de pagamento</v-label>
            </div>

            <FormaToggle v-model="forma_pagamento" class="mt-5" :multiplas-cotas="multiplasCotas" :cartao="permitir_cartao" boleto :link="permitir_cartao" />

            <FormaCartao id="FormaCartao" v-if="forma_pagamento === FormasPagamento.Cartao && permitir_cartao" v-model="cartao" :bandeiras-base="bandeiras_base" ref="form" class="mt-5" />

            <p v-if="forma_pagamento === FormasPagamento.Link" class="ml-12 pt-7 pr-12 pl-12 font-weight-bold">* Link enviado ao e-mail do cliente para conclusão do próprio pagamento via cartão de crédito ou boleto.</p>

            <div class="card-resumo text--primary text-center px-10 py-5 mt-3 mx-auto">
                <div class="text-primary-color" v-html="textoPrimeiraParcela || '-'"></div>
                <div class="text-primary-color py-1" v-if="multiplasCotas">
                    {{ textoCotas }}
                </div>
                <div class="text-primary-color mb-3">Valor total da 1ª parcela a pagar</div>
                <v-btn v-if="desconto" @click="swapAlterarValor" color="primary" style="font-size: 18px; box-shadow: 2px 2px 4px #000000;" id="alterar_valor_parcela">Alterar valor da 1ª parcela</v-btn>
                <div v-if="desconto && parseFloat(pedido.plano.valor_parcela) !== parseFloat(pedido.bem.vl_original)" style="">
                    <br />
                    *Valor original {{ pedido.bem.vl_original * quantidadeCotasVenda || 0 | money }}
                    <br />
                </div>
            </div>
        </div>

        <v-flex class="mt-9">
            <v-layout class="justify-space-between">
                <v-btn color="secondary" class="mt-5" @click="voltar">Voltar</v-btn>
                <v-btn id="ButtonFinalizar" class="mt-5" color="primary" @click="verificarQuantidadeFiliais">
                    Finalizar venda
                </v-btn>
            </v-layout>
        </v-flex>

        <v-dialog v-model="show_aterar_valor" persistent max-width="500">
            <v-card>
                <v-toolbar class="text-center col-12">
                    <v-toolbar-title class="col-11">Alterar valor da 1ª parcela</v-toolbar-title>

                    <v-btn class="col-1" icon @click="show_aterar_valor = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container class="container">
                    <v-flex class="col-12 text-center">
                        <label class="card-resumo text--bold text--primary">*Valor original <span v-if="multiplasCotas">total</span> {{ pedido.bem.vl_original * quantidadeCotasVenda || 0 | money }}</label>
                        <br />
                        <label class="label-style text--primary">Você pode reduzir até {{ porcentagem }}% do valor total da primeira parcela</label>
                        <MoneyTextField
                                label=""
                                outlined
                                v-model="valor_com_desconto"
                                :maxvalue="valor_parcela_original * quantidadeCotasVenda"
                                @focus="ultrapassado_vl_minimo = false"
                                id="valor_com_desconto"
                                maxlength="14" />
                    </v-flex>
                    <v-flex class="col-12">
                        <v-btn class="col-4" color="secondary" @click="show_aterar_valor = false" id="fechar"> Cancelar </v-btn>
                        <v-btn class="col-4  offset-md-4" color="primary" @click="ajustaValorMinimo" id="alterar"> Confirmar </v-btn>
                    </v-flex>
                </v-container>
            </v-card>
        </v-dialog>
        <ListDialog v-model="dialog_filial"
                    title="ESCOLHA A FILIAL"
                    :items="filiais_visiveis"
                    :search-keys="['CD_Filial_Venda','NM_Filial_Venda']"
                    @select="selecionarFilial"
                    :item-text="filialTextDialog" />
    </v-container>
</template>

<script>
  import Color from 'color'
  import moment from 'moment'
  import { FormasPagamento } from '@/plugins/constants'
  import { alert, notification, formatarMoedaBrl } from '@/plugins/helpers'
  import { colorRes } from '@/plugins/flavors'
  import FormaToggle from './FormaToggle'
  import FormaCartao from './FormaCartao'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import { mapGetters, mapState } from 'vuex'
  import { pedido_default } from '../../../plugins/pedido_default'
  import loadFiliais from '../../../mixins/loadFiliais'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import realizarVendaMixin from '../../../mixins/realizarVendaMixin'
  import enviarBoletoMixin from '../../../mixins/enviarBoletoMixin'
  import Banner from '../../../components/common/Banner.vue'
  import { BoletoMensagens } from '../../../enums/boletos/messages'
  import { MENSAGENS_ENDERECO } from '../../../enums/endereco/messages'
  import { get } from 'lodash'
  import { MensagensSucessoPagamento } from '@/enums/pagamento/mensagensPagamento'
  import { MensagensSucessoProposta } from '@/enums/propostas/mensagensSucessoProposta'
  import deployValidation from '@/mixins/deployValidation'
  export default {
    name: 'FormaPagamento',
    components: { FormaToggle, FormaCartao, Banner },
    mixins: [loadFiliais, realizarVendaMixin, enviarBoletoMixin, deployValidation],
    props: { value: Object },
    data: () => ({
      permitir_cartao: false,
      dialog_filial: false,
      valorAlterado: '',
      show_aterar_valor: false,
      ultrapassado_vl_minimo: false,
      desconto: false,
      valor_minimo_desconto: null,
      valor_com_desconto: null,
      valor_parcela_original: null,
      hasDesconto: false,
      enable_alterar_valor: false,
      porcentagem: null,
      pedido: pedido_default,
      cartao: {
        numero_cartao: '',
        nome_cliente: '',
        expiracao: '',
        bandeira: '',
        cvv: ''
      },
      forma_pagamento: FormasPagamento.Boleto,
      filiais_visiveis: [],
      vendedor: true,
      bandeiras_base: []
    }),
    computed: {
      ...mapState([
        'id_usuario',
        'id_empresa',
        'jornada_venda',
        'vendas_backoffice',
        'hierarquia_comercial'
      ]),
      ...mapGetters([
        'filiais'
      ]),
      textoPrimeiraParcela () {
        if (this.multiplasCotas) {
          const valorUnitario = this.pedido.bem.vl_c_desconto ? this.pedido.bem.vl_c_desconto : this.pedido.plano.valor_parcela
          let valorMultiplo = formatarMoedaBrl(valorUnitario * this.quantidadeCotasVenda)

          if (this.forma_pagamento === this.FormasPagamento.Cartao) {
            return `<strong>Valor total da transação: ${valorMultiplo}</strong>`
          }
          return `<strong>Valor total ${valorMultiplo}</strong>`
        }
        const valor = this.pedido.bem.vl_c_desconto ? this.pedido.bem.vl_c_desconto : this.pedido.plano.valor_parcela
        const valorFormatado = formatarMoedaBrl(valor)
        return valorFormatado
      },
      textoCotas () {
        const valorUnitario = this.pedido.bem.vl_c_desconto ? this.pedido.bem.vl_c_desconto : this.pedido.plano.valor_parcela
        const valorFormatado = formatarMoedaBrl(valorUnitario)
        if (this.forma_pagamento === this.FormasPagamento.Boleto) {
          return `${this.quantidadeCotasVenda} boletos de ${valorFormatado}`
        }
        return `${this.quantidadeCotasVenda} cotas de ${valorFormatado}`
      },
      rotas: () => ({
        vendas: '/vendas',
        pagamento: '/pagamento',
        boleto: '/proposta/boleto/enviar',
        desconto: '/proposta/descontar',
        configuracaoPagamento: '/configuracaopagamento/get'
      }),
      FormasPagamento: () => FormasPagamento,
      cssProps () {
        return {
          '--accentTransparent': Color(colorRes().accent).alpha(0.15)
        }
      },
      multiplasCotas () {
        return this.pedido.carrinho.qt_cotas > 1
      },
      quantidadeCotasVenda () {
        if (this.pedido.carrinho && this.pedido.carrinho.qt_cotas) {
          return this.pedido.carrinho.qt_cotas
        }
        return 1
      }
    },
    watch: {
      forma_pagamento (val) {
        this.desconto = (this.hasDesconto)
        if (this.desconto) {
          this.pedido.plano.valor_parcela = parseFloat(this.pedido.bem.vl_c_desconto) > 0 ? this.pedido.bem.vl_c_desconto : this.pedido.bem.vl_original
        }
      },
      valor_com_desconto (val) {
        if (val && val > 0) {
          this.valorAlterado = '*'
          this.enable_alterar_valor = true
        } else {
          this.enable_alterar_valor = false
        }
      }
    },
    created () {
      if (typeof this.$route.params.vendedor !== 'undefined') {
        this.vendedor = this.$route.params.vendedor
        this.bandeiras_base = this.$route.params.bandeiras_base
      }
      this.$http.get(`${this.rotas.vendas}/${this.value.id_pedido}`)
        .then(async res => {
          res.data.cliente = { ...this.pedido.cliente, ...res.data.cliente }
          res.data.produto = { ...this.pedido.produto, ...res.data.produto }
          res.data.bem = { ...this.pedido.bem, ...res.data.bem }
          res.data.grupo = { ...this.pedido.grupo, ...res.data.grupo }
          res.data.plano = { ...this.pedido.plano, ...res.data.plano }
          this.pedido = { ...this.pedido, ...res.data }

          if (this.vendedor) {
            await this.loadBandeiras()
            await this.loadPermissaoVendaCartao()
            await this.loadFiliais()
          }
          this.$http.get('/configuracaopagamento/get')
            .then(result => {
              if (result.data) {
                this.hasDesconto = result.data.ativo
                this.desconto = result.data.ativo
                this.porcentagem = result.data.porcentagem
                this.valor_parcela_original = this.pedido.plano.valor_parcela
                this.valor_minimo_desconto = parseFloat(this.pedido.plano.valor_original - (this.pedido.plano.valor_original / 100 * this.porcentagem))
              }
            })
        })
    },
    methods: {
      async loadPermissaoVendaCartao () {
        await this.$http.get(`/proposta/cartao/venda_cartao/${this.id_usuario}/${this.id_empresa}`)
          .then(res => {
            this.permitir_cartao = res.data.permitido
            if (this.permitir_cartao && !this.multiplasCotas) {
              this.forma_pagamento = this.FormasPagamento.Cartao
            }
          })
      },
      filialTextDialog (item) { return `${item.CD_Filial_Venda} - ${item.NM_Filial_Venda}` },
      selecionarFilial (filial) {
        this.$session.set('filial', filial)
        this.$http.post('/vendas/alterar_filial', {
          id_pedido: this.pedido.id_pedido,
          id_filial: filial['ID_Filial_Venda'],
          nm_filial: filial['NM_Filial_Venda'],
          cd_filial: filial['CD_Filial_Venda']
        })

        this.dialog_filial = false

        this.validarPedido()
      },
      voltar () {
        alert({
          text: 'Tem certeza que deseja sair da tela de pagamento?\nOs dados atuais não serão salvos.',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': () => {
              this.alterarValor(true)
              this.$emit('prevPage')
            }
          }
        })
      },
      ajustaValorMinimo () {
        let valor = this.valor_com_desconto / this.quantidadeCotasVenda
        if (parseFloat(valor) > 0 && parseFloat(valor) < this.valor_minimo_desconto) {
          this.ultrapassado_vl_minimo = true
          this.enable_alterar_valor = false
          notification(AlertTypes.WARN, 'O valor inserido ultrapassa o limite máximo de desconto. Por favor, altere o valor do desconto e tente novamente.')
        } else {
          this.ultrapassado_vl_minimo = false
          this.enable_alterar_valor = true

          if (parseFloat(valor) > 0 && parseFloat(valor) >= this.valor_minimo_desconto) {
            this.alterarValor(false)
            this.swapAlterarValor()
          }
        }
      },
      alterarValor (reset_desconto) {
        if (reset_desconto) {
          this.$http.post(this.rotas.desconto, { id_pedido: this.pedido.id_pedido, valor_com_desconto: 0 })
        } else {
          if (this.valor_com_desconto && this.valor_com_desconto > 0) {
            this.$http.post(this.rotas.desconto, { id_pedido: this.pedido.id_pedido, valor_com_desconto: this.valor_com_desconto / this.quantidadeCotasVenda })
              .then(result => {
                this.pedido.plano.valor_parcela = this.valor_com_desconto / this.quantidadeCotasVenda
                this.pedido.bem.vl_c_desconto = this.valor_com_desconto / this.quantidadeCotasVenda
                this.valor_com_desconto = null
              })
          }
        }
      },
      swapAlterarValor () {
        this.show_aterar_valor = !this.show_aterar_valor
      },
      verificarQuantidadeFiliais () {
        if (this.vendedor) {
          if (this.filiais_visiveis.length > 1) {
            this.dialog_filial = true
          } else {
            const filial = this.filiais_visiveis[0]
            this.selecionarFilial(filial)
          }
        } else {
          this.validarPedido()
        }
      },
      validarPedido () {
        const form = this.$refs.form
        if (!form || form.validate()) {
          const now = moment().format('YYYY-MM-DD')
          const data_validade = this.pedido.data_validade
          if (!data_validade || now < data_validade) {
            const { Cartao, Boleto, Link } = FormasPagamento
            const msg = {
              [Cartao]: 'cartão de crédito',
              [Boleto]: 'boleto',
              [Link]: 'link por e-mail'
            }
            alert({
              text: `Confirma a forma de pagamento escolhida como ${msg[this.forma_pagamento]}?`,
              buttons: {
                'Cancelar': () => true,
                'Confirmar': () => {
                  this.finalizar(this.pedido.instancia_cliente.email)
                }
              }
            })
          } else {
            notification(AlertTypes.WARN, 'Esta venda está expirada e não pode ser paga')
          }
        }
      },
      async enviarCartao () {
        try {
          this.$store.commit('setAdditionalLoadingText', 'Processando a transação do cartão, este processo pode levar alguns minutos!')
          const cartao = { ...this.cartao, numero_cartao: this.cartao.numero_cartao.replace(/\s+/g, '') }

          await this.$http.get(this.rotas.vendas + '/' + this.pedido.id_pedido)
          const resposta = await this.$http.post(
            this.rotas.pagamento,
            { id_pedido: this.pedido.id_pedido, cartao, id_usuario: this.vendedor ? this.id_usuario : 0 },
            { options: { showAdditionalLoadingText: true } }
          )

          this.$emit('input', this.pedido)

          let msg_sucesso = 'Pagamento com cartão de crédito realizado com sucesso!'
          let alertType = AlertTypes.SUCCESS
          if (!resposta.data.atualizou_pedido_bd_intermediario) {
            alertType = AlertTypes.WARN
            msg_sucesso += ' Contudo, houve um erro inesperado em nosso servidor, informe ao administrador do sistema. Por favor, não efetue um novo pagamento para essa venda.'
          }

          return { type: alertType, mensagem: msg_sucesso }
        } catch (err) {
          notification(AlertTypes.ERROR, err.response.data.Msg_Erro, false, false, true)
          throw err
        }
      },
      async atualizarEmail (email) {
        const { id_cliente, email: email_antigo } = this.pedido.cliente

        if (email_antigo !== email) {
          await this.$http.patch(`/clientes/${id_cliente}/email`, { email })

          this.pedido.cliente.email = email

          this.$emit('input', this.pedido)
        }
      },
      async finalizar (email) {
        let sucessoGerarVenda = false
        try {
          if (!(await this.validarDeploy())) {
            return
          }
          const enderecoValido = await this.verifyAddress(this.pedido)
          if (!enderecoValido) {
            notification(AlertTypes.ERROR, MENSAGENS_ENDERECO.ERRO_BUSCAR_ENDERECO)
            return
          }
          let objPagamento = null

          this.sendAnalytics()
          if (this.multiplasCotas && (this.forma_pagamento === FormasPagamento.Cartao || this.forma_pagamento === FormasPagamento.Link)) {
            const cartao = { ...this.cartao, numero_cartao: this.cartao.numero_cartao.replace(/\s+/g, '') }
            const id_usuario = this.vendedor ? this.id_usuario : 0
            if (this.forma_pagamento === FormasPagamento.Cartao) {
              await this.realizarVendaCarrinhoAtreladoPagamento(this.pedido.id_pedido, this.forma_pagamento, this.cartao.bandeira, cartao, id_usuario)
            } else {
              await this.realizarVendaCarrinhoComLink(this.pedido.id_pedido, this.forma_pagamento, this.cartao.bandeira, id_usuario, email)
            }

            sendAnalyticsEvent(this.$gtag, 'venda_realizada_carrinho', {
              id_usuario: this.$session.get('id_usuario'),
              pv: this.$session.get('id_ponto_venda'),
              comissionado: this.$session.get('id_comissionado'),
              hierarquia: this.$session.get('hierarquia_comercial'),

              cliente: this.pedido.cliente.id_cliente,
              cliente_cpf_cnpj: this.pedido.cliente.cpf ? this.pedido.cliente.cpf : this.pedido.cliente.cnpj,
              qtd_cotas_vendidas: this.pedido.carrinho.qt_cotas,
              produto: this.pedido.produto.id_produto,
              grupo: this.pedido.grupo.id_grupo,
              bem: this.pedido.bem.id_bem,
              plano: this.pedido.plano.id_plano_venda,
              prazo: this.pedido.plano.prazo_comercializacao,
              marca: this.$session.get('flavor'),
              empresa: this.$session.get('id_empresa')
            })

            const mensagemSucesso = this.forma_pagamento === FormasPagamento.Cartao ? MensagensSucessoPagamento.cartao : MensagensSucessoPagamento.link
            objPagamento = { type: AlertTypes.SUCCESS, mensagem: mensagemSucesso }
          } else {
            await this.realizarVenda(this.pedido.id_pedido, this.forma_pagamento, this.cartao.bandeira)
            objPagamento = { type: AlertTypes.SUCCESS }
            sucessoGerarVenda = true
          }
          this.pedido.enviado = true

          if (!this.multiplasCotas) {
            objPagamento = await this.pagamentoPropostaUnica(email)
          }
          const { data } = await this.$http.get(`/vendas/${this.pedido.id_pedido}`)
          this.pedido = { ...this.pedido, ...data }
          this.$emit('input', this.pedido)

          let TextoPropostaSucesso = this.multiplasCotas ? MensagensSucessoProposta.multipla : MensagensSucessoProposta.comum
          const TextoPagamentoSucesso = (objPagamento && objPagamento.mensagem) ? objPagamento.mensagem : ''
          const tipoNotificacao = (objPagamento && objPagamento.type) ? objPagamento.type : AlertTypes.SUCCESS
          notification(tipoNotificacao, TextoPropostaSucesso + TextoPagamentoSucesso, '', false, false, false)

          if (this.pedido.assinatura_obrigatoria && this.pedido.origem_assinatura !== 'pagamento') {
            if (this.multiplasCotas) {
              this.$emit('finalizado')
            }
            this.$emit('nextPage')
          } else {
            this.$emit('finalizado')
            this.$router.replace('/')
          }
        } catch (err) {
          const erroApi = get(err, 'response.data.Msg_Erro', null)
          const mensagemAdicional = sucessoGerarVenda ? 'Sua proposta foi gerada com sucesso, porém houve um erro no pagamento. Erro: ' : ''
          if (erroApi) {
            notification(AlertTypes.ERROR, mensagemAdicional + erroApi)
          }
          notification(AlertTypes.ERROR, sucessoGerarVenda + err.message, err.message)
        }
      },
      async verifyAddress (pedido) {
        const verifyAddressPayload = {
          id_costumer: pedido.cliente.id_cliente,
          person_type: pedido.cliente.pessoa,
          addresses: pedido.cliente.enderecos
        }

        try {
          const response = await this.$http.post('/customer/verify-address', verifyAddressPayload)
          return response.data.ok
        } catch (error) {
          console.error('Error verifying address:', error)
          throw error
        }
      },
      async pagamentoPropostaUnica (email) {
        let objPagamento = null
        switch (this.forma_pagamento) {
          case FormasPagamento.Boleto:
            await this.enviarBoleto(this.pedido.id_pedido, email, this.vendedor)
            objPagamento = { type: AlertTypes.SUCCESS, mensagem: BoletoMensagens.PAGAMENTO_SUCESSO_BOLETO }
            break
          case FormasPagamento.Cartao:
            objPagamento = await this.enviarCartao()
            break
          case FormasPagamento.Link:
            objPagamento = await this.enviarLinkPagamento(email)
            break
        }
        return objPagamento
      },
      sendAnalytics () {
        sendAnalyticsEvent(this.$gtag, 'venda_finalizada2', {
          forma_pagamento: this.forma_pagamento,
          valor_parcela: this.pedido.plano.valor_parcela,
          source_menu: this.jornada_venda
        })
      },
      async enviarLinkPagamento (email) {
        await this.$http.post('/proposta/linkpagamento', { id_pedido: this.pedido.id_pedido, email })
        return { type: AlertTypes.SUCCESS, mensagem: 'Em breve o cliente receberá o link para pagamento.' }
      },
      async loadBandeiras () {
        this.$http.get(`/pagamento/bandeiras/${this.$session.get('id_empresa')}`)
          .then(async (res) => {
            this.bandeiras_base = res.data
          })
          .catch(() => {
            notification(AlertTypes.ERROR, 'Não foi possível buscar as bandeiras')
          })
      }
    }
  }
</script>

<style scoped lang="scss">
.forma-pagamento {
    max-width: 600px;
}

.label-style {
    font-size: 14px;
}

.card-resumo {
    background-color: var(--accentTransparent);
    border-radius: 10px;
    font-size: 1.5rem;
    width: fit-content;
}

.text--multiple_quotes{
  color:var(--advice_friendly);
  font-size: 1.1rem;
  padding:8px;
}

.text-primary-color{
  color:var(--primary);
}
</style>
